/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import {
  LOADER_STATUS,
  PROFILE_DATA,
  SET_ENTITY_LIST,
  DEFAULT_ENTITY,
  STORE_GSTIN_GSTR8,
  STORE_PERIOD_SINGLE,
  REJECTED_TABLE_DATA,
  SET_IS_EDIT,
  EDITED_VALUE,
  GROSS_SUMMARY_TABLE_DATA,
  SAVE_TABLE_DATA,
  COMPARATIVE_TABLE_DATA,
  HISTORY_TABLE_DATA,
  SAVE_TOTAL_PAGES,
  SET_EDITED_DATA,
} from "./constants";

// The initial state of the App
export const initialState = {
  data: [],
  loaderStatus: false,
  profileData: [],
  entityMasterList: [],
  defaultEntity: "",
  selectedGstin: [],
  selectedPeriodSingle: null,
  rejectedTableData:[],
  grossSummaryTableData:[],
  saveTableData:[],
  comparativeTableData:[],
  historyTableData:[],
  isEdit: false,
  editedValue:[],
  totalPages: 1,
  editedData:[],

};

/* eslint-disable default-case, no-param-reassign */
const gstr8PrepareDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };

    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };

    case SET_ENTITY_LIST:
      return {
        ...state,
        entityMasterList: action.payload,
      };
    case DEFAULT_ENTITY:
      return {
        ...state,
        defaultEntity: action.data,
      };
    case STORE_GSTIN_GSTR8:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case STORE_PERIOD_SINGLE:
      return {
        ...state,
        selectedPeriodSingle: action.date,
      };
      case REJECTED_TABLE_DATA:
        return {
          ...state,
          rejectedTableData:action.rejectedTableData
        }
      case GROSS_SUMMARY_TABLE_DATA:
        return {
          ...state,
          grossSummaryTableData:action.grossSummaryData
        }
      case SAVE_TABLE_DATA:
        return {
          ...state,
          saveTableData:action.saveData
        }
        case COMPARATIVE_TABLE_DATA:
        return {
          ...state,
          comparativeTableData:action.comparativeTableData
        }
        case HISTORY_TABLE_DATA:
        return {
          ...state,
          historyTableData:action.historyTableData
        }
        case SET_IS_EDIT:
        return {
          ...state,
          isEdit: action.data
        }
        case EDITED_VALUE:
        return {
          ...state,
          editedValue: action.editedValue
        }
        case SAVE_TOTAL_PAGES:
          return {
            ...state,
            totalPages:action.pages
          }
        case SET_EDITED_DATA:
          return {
            ...state,
            editedData:action.data
          }
    default:
      return state;
  }
};

export default gstr8PrepareDataReducer;
